import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    // this.observer = new MutationObserver(this.handleMutations.bind(this));
    // this.observer.observe(this.element, { childList: true, subtree: true });

    this.groupEvents(); // Initial render
  }

  disconnect() {
    // this.observer.disconnect();
  }

  handleMutations(mutations) {
    const addedNodes = mutations.some(m => m.addedNodes.length > 0);
    if (addedNodes) this.groupEvents();
  }

  groupEvents() {
    const items = Array.from(this.element.querySelectorAll("[data-date]"));
    const groups = {};

    items.forEach(item => {
      const dateStr = item.getAttribute("data-date");
      const date = new Date(dateStr);

      if (isNaN(date)) return;

      const monthKey = `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, "0")}`;
      const weekNumber = this.getWeekOfMonthMondayStart(date);
      const weekKey = `Week ${weekNumber}`;
      const dayKey = date.toISOString().split("T")[0]; // YYYY-MM-DD

      if (!groups[monthKey]) groups[monthKey] = {};
      if (!groups[monthKey][weekKey]) groups[monthKey][weekKey] = {};
      if (!groups[monthKey][weekKey][dayKey]) groups[monthKey][weekKey][dayKey] = [];

      groups[monthKey][weekKey][dayKey].push(item);
    });

    this.renderGroups(groups);
  }

  groupEventsWithoutDay() {
    const items = Array.from(this.element.querySelectorAll("[data-date]"));
    const groups = {};

    items.forEach(item => {
      const dateStr = item.getAttribute("data-date");
      const date = new Date(dateStr); // ISO 8601 UTC format is safe here

      if (isNaN(date)) return; // Skip invalid dates

      const monthKey = `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1)
        .toString()
        .padStart(2, "0")}`;
      const weekNumber = this.getWeekOfMonthMondayStart(date);
      const weekKey = `Week ${weekNumber}`;

      if (!groups[monthKey]) groups[monthKey] = {};
      if (!groups[monthKey][weekKey]) groups[monthKey][weekKey] = [];

      groups[monthKey][weekKey].push(item);
    });

    this.renderGroups(groups);
  }

  getCurrentWeekKey() {
    const now = new Date();
    const currentMonthKey = `${now.getUTCFullYear()}-${(now.getUTCMonth() + 1)
      .toString()
      .padStart(2, "0")}`;
    const currentWeekNumber = this.getWeekOfMonthMondayStart(now);
    return `${currentMonthKey}-Week ${currentWeekNumber}`;
  }

  getWeekOfMonthMondayStart(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const day = date.getUTCDate();

    const firstOfMonth = new Date(Date.UTC(year, month, 1));
    let firstDayWeekday = firstOfMonth.getUTCDay(); // Sunday=0..Saturday=6
    firstDayWeekday = (firstDayWeekday + 6) % 7; // Adjust so Monday=0

    return Math.ceil((day + firstDayWeekday) / 7);
  }

  getOrdinalWord(number) {
    const words = [
      "First", "Second", "Third", "Fourth", "Fifth",
      "Sixth", "Seventh", "Eighth", "Ninth", "Tenth"
    ];
    return words[number - 1] || `Week ${number}`;
  }

  getWeekDateRange(date) {
    const weekday = date.getUTCDay(); // Sunday = 0
    const dayOffset = (weekday + 6) % 7; // Monday = 0, Sunday = 6
    const monday = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate() - dayOffset));
    const sunday = new Date(Date.UTC(monday.getUTCFullYear(), monday.getUTCMonth(), monday.getUTCDate() + 6));

    const format = (d) =>
      d.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        timeZone: "UTC",
      });

    return `${format(monday)} – ${format(sunday)}`;
  }

  renderGroups(groups) {
    this.element.innerHTML = "";
    const currentWeekKey = this.getCurrentWeekKey();

    for (const monthKey in groups) {
      const [year, month] = monthKey.split("-");
      const monthDate = new Date(Date.UTC(parseInt(year), parseInt(month) - 1));
      const monthName = monthDate.toLocaleString("en-US", {
        month: "long",
        year: "numeric",
        timeZone: "UTC"
      });

      const monthSection = document.createElement("div");
      monthSection.classList.add("month-group");
      monthSection.classList.add("mt-3");
      monthSection.innerHTML = `<h3 class="month-name mb-0">${monthName}</h3>`;

      for (const weekKey in groups[monthKey]) {
        const weekNumber = parseInt(weekKey.match(/\d+/)?.[0] || 0);
        const isCurrent = `${monthKey}-${weekKey}` === currentWeekKey;
        const weekLabel = isCurrent ? "This" : this.getOrdinalWord(weekNumber);

        const anyDay = Object.keys(groups[monthKey][weekKey])[0];
        const rangeLabel = this.getWeekDateRange(new Date(anyDay));

        const weekSection = document.createElement("div");
        weekSection.classList.add("week-group");
        // weekSection.innerHTML = `<h3>${weekLabel} week (${rangeLabel})</h3>`;
        weekSection.innerHTML = `<h6 class="text-danger pt-3 mb-0 fw-bold week-heading">${weekLabel} week (${rangeLabel})</h6>`;

        const days = Object.keys(groups[monthKey][weekKey]).sort(); // sort by date

        days.forEach(dayKey => {
          const dayDate = new Date(dayKey);
          const dayLabel = dayDate.toLocaleDateString("en-US", {
            weekday: "long",
            month: "long",
            day: "2-digit",
            timeZone: "UTC"
          });

          const daySection = document.createElement("div");
          daySection.classList.add("day-group");
          const heading = document.createElement("h4");
          heading.textContent = dayLabel;

          const wrapper = document.createElement("div");
          wrapper.classList.add("day-events");

          groups[monthKey][weekKey][dayKey].forEach(item => {
            wrapper.appendChild(item);
          });

          // daySection.appendChild(heading);
          daySection.appendChild(wrapper);
          weekSection.appendChild(daySection);
        });

        monthSection.appendChild(weekSection);
      }

      this.element.appendChild(monthSection);
    }
  }

  renderGroupsWithoutDay(groups) {
    this.element.innerHTML = ""; // Clear existing DOM

    for (const monthKey in groups) {
      const [year, month] = monthKey.split("-");
      const monthDate = new Date(Date.UTC(parseInt(year), parseInt(month) - 1));
      const monthName = monthDate.toLocaleString("en-US", {
        month: "long",
        year: "numeric",
        timeZone: "UTC"
      });

      const monthSection = document.createElement("div");
      monthSection.classList.add("month-group");
      monthSection.innerHTML = `<h3 class="mb-0">${monthName}</h3>`;

      for (const week in groups[monthKey]) {
        const weekNumber = parseInt(week.match(/\d+/)?.[0] || 0);
        // const weekLabel = this.getOrdinalWord(weekNumber);

        const currentWeekKey = this.getCurrentWeekKey();
        const currentKey = `${monthKey}-${week}`;
        const weekLabel =
          currentKey === currentWeekKey
            ? "This"
            : this.getOrdinalWord(weekNumber);

        // Use first event’s date for calculating the week range
        const eventDate = groups[monthKey][week].length > 0
          ? new Date(groups[monthKey][week][0].getAttribute("data-date"))
          : null;

        const rangeLabel = eventDate ? this.getWeekDateRange(eventDate) : "";

        const weekSection = document.createElement("div");
        weekSection.classList.add("week-group");
        weekSection.innerHTML = `<h6 class="text-danger pt-2 pb-2 fw-bold">${weekLabel} week (${rangeLabel})</h6>`;

        groups[monthKey][week].forEach(item => {
          weekSection.appendChild(item);
        });

        monthSection.appendChild(weekSection);
      }

      this.element.appendChild(monthSection);
    }
  }
}
